import create from 'zustand';

/**
 * 신고하기 모달팝업
 */
export type ContentEditType = 'edit-content' | 'edit-comment';
export type ContentDeleteType = 'delete-content' | 'delete-comment';
export type ModalJobdomEditorMode = 'write' | 'edit';

interface ModalBase {
  open: boolean;
}

interface ModalReportStore extends ModalBase {
  jobdomNumber?: number;
  commentNumber?: number;
}

export interface ModalJobdomEditorStore extends ModalBase {
  mode: ModalJobdomEditorMode;
  jobdomNumber?: number;
  categoryId?: string;
  content?: string;
  password?: string;
  companyName?: string;
  PK_NM_HASH?: string;
  hashtags?: string[];
  title?: string;
  userName?: string;
  onSuccess?: () => void;
}

export interface ModalAuthContentStore extends ModalBase {
  onAuthenticated?: (password?: string) => void;
  type?: ContentEditType;
  contentId?: number;
}

export interface ModalDeleteContentStore extends Omit<ModalAuthContentStore, 'type'> {
  type?: ContentDeleteType;
}

interface JobdomBoardStore {
  currentCategory: string;
  modalReport: ModalReportStore;
  modalAuthContent: ModalAuthContentStore;
  modalDeleteContent: ModalDeleteContentStore;
  modalJobdomEditor: ModalJobdomEditorStore;
  setCurrentCategory: (category: string) => void;
  setModalReport: (newState: ModalReportStore) => void;
  setModalAuthContent: (newState: ModalAuthContentStore) => void;
  setModalDeleteContent: (newState: ModalDeleteContentStore) => void;
  setModalJobEditor: (newState: ModalJobdomEditorStore) => void;
  resetModalReport: () => void;
  resetModalAuthContent: () => void;
  resetModalDeleteContent: () => void;
  resetModalJobEditor: () => void;
}

const initialState: Pick<
  JobdomBoardStore,
  | 'modalReport'
  | 'modalAuthContent'
  | 'modalDeleteContent'
  | 'modalJobdomEditor'
  | 'currentCategory'
> = {
  currentCategory: 'A',
  modalReport: {
    open: false,
    jobdomNumber: undefined,
    commentNumber: undefined,
  },
  modalJobdomEditor: {
    open: false,
    mode: 'write',
    jobdomNumber: undefined,
    categoryId: undefined,
    content: undefined,
    password: undefined,
    companyName: undefined,
    PK_NM_HASH: undefined,
    hashtags: undefined,
    title: undefined,
    userName: undefined,
    onSuccess: undefined,
  },
  modalAuthContent: {
    open: false,
    type: undefined,
    onAuthenticated: undefined,
    contentId: undefined,
  },
  modalDeleteContent: {
    open: false,
    type: undefined,
    onAuthenticated: undefined,
    contentId: undefined,
  },
};

const useJobdomBoardStore = create<JobdomBoardStore>((set) => ({
  ...initialState,
  setCurrentCategory: (category) => set(() => ({ currentCategory: category })),
  setModalReport: (newState: ModalReportStore) => set(() => ({ modalReport: newState })),
  resetModalReport: () => set(() => ({ modalReport: { ...initialState.modalReport } })),
  setModalAuthContent: (newState) => set(() => ({ modalAuthContent: newState })),
  setModalDeleteContent: (newState) => set(() => ({ modalDeleteContent: newState })),
  setModalJobEditor: (newState) => set(() => ({ modalJobdomEditor: newState })),
  resetModalAuthContent: () =>
    set(() => ({
      modalAuthContent: { ...initialState.modalAuthContent },
    })),
  resetModalDeleteContent: () =>
    set(() => ({
      modalDeleteContent: { ...initialState.modalDeleteContent },
    })),
  resetModalJobEditor: () =>
    set(() => ({
      modalJobdomEditor: { ...initialState.modalJobdomEditor },
    })),
}));

export default useJobdomBoardStore;
